// extracted by mini-css-extract-plugin
module.exports = {"pagin":"pagination_pagin__c-aQQ","pagin__item":"pagination_pagin__item__2umlE","pagin__item__active":"pagination_pagin__item__active__2JxO-"};